import Vue from "vue";
import dateFormats, { DEFAULT_TIME_FORMAT_MINUTES } from "@/static/dateFormats";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

export const filterFormatTimeMinutes = (value: string | Date): string => {
  if (!value) return "";
  return dayjs(value, dateFormats, false).format(DEFAULT_TIME_FORMAT_MINUTES);
};

Vue.filter("formatTimeMinutes", filterFormatTimeMinutes);
